import React from "react";
import { ArrowRight, Zap } from "lucide-react";
import "./Hero.css";

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-container">
        <div className="hero-badge">
          <Zap size={16} className="badge-icon" />
          <span>Innovation Meets Excellence</span>
        </div>
        
        <h1 className="hero-title">
          Experience the Future of
          <span className="gradient-text"> Consumer Electronics</span>
        </h1>
        
        <p className="hero-description">
          Cutting-edge technology designed for the modern lifestyle. 
          Discover premium devices that blend innovation, performance, and style.
        </p>
        
        <div className="hero-buttons">
          <button className="btn-primary" onClick={() => scrollToSection("why-choose-us")}>
            Learn More
            <ArrowRight size={20} style={{ marginLeft: "8px" }} />
          </button>
          <button className="btn-secondary" onClick={() => scrollToSection("contact")}>
            Get in Touch
          </button>
        </div>

        <div className="hero-stats">
          <div className="stat-item">
            <div className="stat-number">50K+</div>
            <div className="stat-label">Happy Customers</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">4.9/5</div>
            <div className="stat-label">Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
